// This is a replacement for the Number.toFixed() method
// It is use to round a number to two decimal places

// Will return a number up to two decimal places
export const toFixedTwoNumber = (number) => Math.round(number * 100) / 100

// Will return a string with two decimal places
export const toFixedTwoString = (number) => (Math.round(number * 100) / 100).toFixed(2)
